import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/flujo';



function craerFlujo(state, action) {
  state.flujos = action.payload.data;
  state.message = action.payload.message;
  state.conexion = false;
  state.error = false;
}



function conexionFlujo(state, action) {
  state.conexion= action.payload.conexion;
}

function errorFlujo(state, action) {
  state.flujos = [];
  state.message = action.payload.message;
  state.conexion = false;
  state.error= true;
}

function craerTiposFlujo(state, action) {
  state.flujosTipo = action.payload.data;
  state.conexion = false;
  state.error = false;
}

const flujoReducer = createSlice({
  name: 'flujo',
  initialState: initState,
  reducers: {
    craerFlujo,
    conexionFlujo,
    errorFlujo,
    craerTiposFlujo,
  },
});

export const flujoActions = {
  ...flujoReducer.actions,
};

export default flujoReducer.reducer;
